import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

/**
 * Submit AI feedback to Cloud Functions
 */
export async function submitAiFeedback(data: AIFeedbackData): Promise<{ success: boolean; error?: string }> {
    try {
        const functions = getFunctions(getApp());
        const submitFn = httpsCallable<AIFeedbackData, { success: boolean; error?: string }>(functions, 'submitAiFeedback');

        const result = await submitFn(data);
        return result.data;
    } catch (error) {
        console.error('Failed to submit feedback:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error occurred'
        };
    }
}
